import { render, staticRenderFns } from "./InstagramInstantwinApplicantTable.vue?vue&type=template&id=661c04bf&scoped=true"
import script from "./InstagramInstantwinApplicantTable.vue?vue&type=script&lang=ts"
export * from "./InstagramInstantwinApplicantTable.vue?vue&type=script&lang=ts"
import style0 from "./InstagramInstantwinApplicantTable.vue?vue&type=style&index=0&id=661c04bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661c04bf",
  null
  
)

export default component.exports